import script from "./InvitePage.vue?vue&type=script&setup=true&lang=js"
export * from "./InvitePage.vue?vue&type=script&setup=true&lang=js"

import "./InvitePage.vue?vue&type=style&index=0&id=0e7323a0&lang=css"

const __exports__ = script;

export default __exports__